__turbopack_context__.v({
  "bgImage": "Tile-module-scss-module__PlSNXG__bgImage",
  "container": "Tile-module-scss-module__PlSNXG__container",
  "content": "Tile-module-scss-module__PlSNXG__content",
  "iconCircle": "Tile-module-scss-module__PlSNXG__iconCircle",
  "text": "Tile-module-scss-module__PlSNXG__text",
  "title": "Tile-module-scss-module__PlSNXG__title",
  "withImage": "Tile-module-scss-module__PlSNXG__withImage",
});
